import React from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO, format } from 'date-fns';

interface DatePickerFieldProps {
  label: string;
  value: string | undefined;
  onChange: (isoDate: string) => void;
  variant?: 'standard' | 'outlined' | 'filled';
  fullWidth?: boolean;
  style?: React.CSSProperties;
}

const DatePickerField: React.FC<DatePickerFieldProps> = ({
  label,
  value,
  onChange,
  variant = 'standard',
  fullWidth,
  style,
}) => {
  const dateValue = value ? parseISO(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        format="MM/dd/yyyy"
        value={dateValue}
        onChange={(date) => onChange(date ? format(date, 'yyyy-MM-dd') : '')}
        slotProps={{
          textField: { variant, fullWidth, style },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerField;
